/**
 * Mapper for home and away Statistics and Set Scores
 */
function mapStats(data) {

  //Mapping set scores
  let homeSets = [];
  let awaySets = [];
  let sets = data.SetScores ? data.SetScores : [0, 0];
  const emptySets = Array(10).fill('-:-').map((sc, i) => sets[i] || sc);

  emptySets.forEach(element => {
    const parts = element.split(':');
    homeSets.push(parts[0]);
    awaySets.push(parts[1]);
  });

  //Mapping statistics
  const homeStats = { sets: [] };
  const awayStats = { sets: [] };

  homeStats.sets = homeSets;
  awayStats.sets = awaySets;

  let statistic = data.Statistics ? data.Statistics : [];

  statistic.forEach(stat => {
    const statValue = stat.Value.split(':').map(Number);
    homeStats[stat.Id] = statValue[0];
    awayStats[stat.Id] = statValue[1];
  });

  return { homeStats, awayStats };
}
export default class StatisticsTrackerModel {
  constructor(data) {
    /**
     * Betradar Id
     * @type {string}
     */
    this.betRadarID = data.BetRadarID;
    /**
     * Current Score
     * @type {array}
     */
    this.score = data.Score ? data.Score.split(':').map(String) : [0, 0];
    /**
     * Period
     * @type {number}
     */
    this.period = data.SetScores ? data.SetScores.length : 0;
    /**
     * Game Score
     * @type {array}
     */
    this.gameScore = data.GameScore ? data.GameScore.split(':').map(String) : [0, 0];
    /**
     * Possession of the ball
     * @type {string}
     */
    this.possession = data.Possession;

    //Home and Away statisics
    const { homeStats, awayStats } = mapStats(data);

    this.homeStats = homeStats;
    this.awayStats = awayStats;
  }
}
